// extracted by mini-css-extract-plugin
export default {"container":"src-feature-form-__address_container","remove":"src-feature-form-__address_remove"};